export const simpleID = length => {
	return new Array(length)
		.fill('0')
		.join('')
		.replace(/[0]/gi, () =>
			// eslint-disable-next-line no-bitwise
			(crypto.getRandomValues(new Uint8Array(1))[0] & 0xf).toString(16)
		);
};
